module.exports = __webpack_public_path__ + "static/media/Reuniclus_gaussian2.098e66f8.png";